import { useContext } from '~/utils/nuxt3-migration'
import AnalyticsService from '~/services/AnalyticsService'

export function useAnalytics(): AnalyticsService {
  return useContext().$analytics
}
